import React, { useState } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  FormControl,
  NativeSelect,
  InputBase,
  Button,
  TextField,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import PageviewIcon from "@material-ui/icons/Pageview";
import ClearAllIcon from "@material-ui/icons/ClearAll";
import { palette, useStylesGlobal } from "configurations/styles/theme";
import { tipoDocumento, tipoAnio } from "./typeVoucher";
import Swal from "sweetalert2";
import { getAnioActual } from "../../../redux/actions/userActions";
import { httpRepo } from "configurations/axios";
var fileSaver = require("file-saver");

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginBottom: "0.5%",
  },
}));

const BootstrapInput = withStyles((theme) => ({
  input: {
    borderRadius: 4,
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    padding: "10px 26px 10px 12px",
  },
}))(InputBase);

export default function SearcVoucher({
  update,
  setUpdate,
  setParamSearch,
  rucEnterprise = "0",
  totalElements ,
}) {
  const classes = useStyles();
  const classesGlobal = useStylesGlobal();

  const [dateStart, setDateStart] = useState("");
  const [dateEnd, setDateEnd] = useState("");
  const [sequential, setSequential] = useState("");
  const [identifier, setIdentifier] = useState("");
  const [type, setType] = useState("");
  const [typeAnio, setTypeAnio] = useState("2026");

  const [cafeFilter, setCafeFilter] = useState("");
  const [inputValue, setInputValue] = useState("");

  const [cufe, setCufe] = useState("");
  const [po, setPo] = useState("");

  const [maxDate] = useState(new Date());
  const [endMaxDate, setEndMaxDate] = useState(new Date());

  const cafeParameters = new Map([
    ["Sin generacion de CAFE", "1"],
    ["CAFE entregado en papel", "2"],
    ["CAFE electrónico", "3"],
  ]);

  const rucAvailablesToCafeFilter = ["1150858-1-571723"];
  const rucAvailablesToCufePo = ["155754584-2-2024"];

  const ExportButton = () => {
    if (update !== 1) return null;
    if (!rucAvailablesToCufePo.includes(rucEnterprise)) return null;

   
  
    return (
     
      <Button
      style={{
        marginLeft: 20,
        backgroundColor: "green", 
        color: "white",     
        textTransform: "none",       
      }}
        variant="contained"
        onClick={handleExport}
      >
        Exportar
      </Button>
    );
  };
  const [loading, setLoading] = useState(false);

  const handleExport = () => {
    if (!totalElements ||  totalElements.length === 0) {
      Swal.fire({
        icon: "info",
        title: "No existen registros para exportar",
        showConfirmButton: true,
        confirmButtonText: "Cerrar",
      });
      return;
    }
    if (totalElements.length > 500) {
      Swal.fire({
        icon: "warning",
        title: "No se puede exportar más de 150 registros",
        html: `Actualmente hay ${ totalElements.length} registros.<br/>Por favor, seleccione al menos un parámetro para exportar.`,
        showConfirmButton: true,
        confirmButtonText: "Cerrar",
      });
      return; 
    }
  
    const objReport = {
      cufes: totalElements || [],
      ruc: rucEnterprise || null,
    };
  
    console.log("Exportando datos...", objReport);
  
    // Mostramos Swal con loading
    setLoading(true);
    Swal.fire({
      title: 'Generando reporte...',
      html: 'Por favor espere mientras se procesa la exportación.',
      didOpen: () => {
        Swal.showLoading();
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
    });
  
    httpRepo
      .post("reporte/comprobantes/emitidos/busqueda", objReport, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        if (response.status === 200) {
          const blob = new Blob([response.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          fileSaver.saveAs(blob, `Comprobantes_emitidos_${Date.now()}.xlsx`);
  
          Swal.fire({
            icon: "success",
            title: "Exportación completa",
            timer: 2000,
            showConfirmButton: false,
          });
        }
      })
      .catch(() => {
        Swal.fire({
          icon: "info",
          title: "No existen datos para los filtros seleccionados",
          showConfirmButton: true,
          confirmButtonText: "Cerrar",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // ================= VALIDACIÓN =================
  const validationInputs = () => {
    let cadena = "";

    if (
      !dateStart &&
      !dateEnd &&
      !sequential &&
      !identifier &&
      !type &&
      !typeAnio &&
      !cafeFilter &&
      !cufe &&
      !po
    ) {
      return Swal.fire({
        icon: "warning",
        title: "Ingrese al menos un parámetro",
        timer: 3000,
        showConfirmButton: false,
      });
    }

    if (dateStart && dateEnd) {
      cadena += `&fechaInicio=${dateStart}&fechaFin=${dateEnd}`;
    }
    if (sequential) cadena += `&secuencial=${sequential}`;
    if (identifier) cadena += `&parametroReceptor=${identifier}`;
    if (type) cadena += `&codigoComprobante=${type}`;
    if (typeAnio) cadena += `&anio=${typeAnio}`;
    if (cafeFilter) {
      cadena += `&tipoEntrega=${cafeParameters.get(cafeFilter)}`;
    }
    if (cufe) cadena += `&cufe=${cufe}`;
    if (po) cadena += `&uid=${po}`;

    cadena += getAnioActual(typeAnio);

    setUpdate(update === 4 ? 3 : 4);
    setParamSearch(cadena);
  };

  // ================= LIMPIAR =================
  const cleanInputs = () => {
    setDateStart("");
    setDateEnd("");
    setSequential("");
    setIdentifier("");
    setType("");
    setTypeAnio("2026");
    setCafeFilter("");
    setCufe("");
    setPo("");
    setUpdate(2);
  };

  const handleStartDateChange = (date) => {
    const endDate = new Date(date);
    setEndMaxDate(new Date(endDate.getTime() + 42 * 86400000));
    setDateStart(date);
    setDateEnd("");
  };

  const CafeFilter = () =>
    rucAvailablesToCafeFilter.includes(rucEnterprise) && (
      <Grid item xs={2}>
        <Autocomplete
          value={cafeFilter}
          onChange={(e, v) => setCafeFilter(v || "")}
          inputValue={inputValue}
          onInputChange={(e, v) => setInputValue(v)}
          options={Array.from(cafeParameters.keys())}
          renderInput={(params) => (
            <TextField {...params} label="CAFÉ" variant="outlined" />
          )}
        />
      </Grid>
    );

  
  return (
    <div className={classes.root}>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <label className={classesGlobal.titleCard}>
            Búsqueda avanzada (Click aquí)
          </label>
        </AccordionSummary>

        <AccordionDetails>
          <Grid container spacing={1}>
            <Grid item xs={2}>Fecha Inicial</Grid>
            <Grid item xs={4}>
              <input
                type="date"
                className="form-control"
                value={dateStart}
                max={maxDate.toISOString().split("T")[0]}
                onChange={(e) => handleStartDateChange(e.target.value)}
              />
            </Grid>

            <Grid item xs={2}>Fecha Final</Grid>
            <Grid item xs={4}>
              <input
                type="date"
                className="form-control"
                value={dateEnd}
                max={endMaxDate.toISOString().split("T")[0]}
                onChange={(e) => setDateEnd(e.target.value)}
              />
            </Grid>

            <Grid item xs={2}>Secuencial</Grid>
            <Grid item xs={4}>
              <input
                className="form-control"
                value={sequential}
                onChange={(e) => setSequential(e.target.value)}
              />
            </Grid>

            <Grid item xs={2}>RUC / Razón Social</Grid>
            <Grid item xs={4}>
              <input
                className="form-control"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
              />
            </Grid>

            <Grid item xs={2}>Año</Grid>
            <Grid item xs={4}>
              <FormControl className="form-control">
                <NativeSelect
                  value={typeAnio}
                  onChange={(e) => setTypeAnio(e.target.value)}
                  input={<BootstrapInput />}
                >
                  {tipoAnio.map((v) => (
                    <option key={v.CODIGO} value={v.VALOR}>
                      {v.NOMBRE}
                    </option>
                  ))}
                </NativeSelect>
              </FormControl>
            </Grid>

            <Grid item xs={2}>Tipo</Grid>
            <Grid item xs={4}>
              <NativeSelect
                value={type}
                onChange={(e) => setType(e.target.value)}
                input={<BootstrapInput />}
              >
                <option value="">--Todos--</option>
                {tipoDocumento.map((v) => (
                  <option key={v.CODIGO} value={v.VALOR}>
                    {v.NOMBRE}
                  </option>
                ))}
              </NativeSelect>
            </Grid>

            <CafeFilter />
            {rucAvailablesToCufePo.includes(rucEnterprise) && (
              <>
                <Grid item xs={2}>
                  <label>CUFE:</label>
                </Grid>
                <Grid item xs={4}>
                  <input
                    className="form-control"
                    value={cufe}
                    onChange={(e) => setCufe(e.target.value)}
                  />
                </Grid>

                <Grid item xs={2}>
                  <label>PO:</label>
                </Grid>
                <Grid item xs={4}>
                  <input
                    className="form-control"
                    value={po}
                    onChange={(e) => setPo(e.target.value)}
                  />
                </Grid>
              </>
            )}

            <Grid item xs={12} style={{ textAlign: "center", marginTop: 20 }}>
              <Button
                variant="contained"
                color="primary"
                startIcon={<PageviewIcon />}
                onClick={validationInputs}
              >
                Buscar
              </Button>

              <Button
                style={{ marginLeft: 20 }}
                variant="outlined"
                color="primary"
                startIcon={<ClearAllIcon />}
                onClick={cleanInputs}
              >
                Limpiar
              </Button>
              <ExportButton />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
